<template>
  <div class="login">
    <div class="login-card">
      <Logo />

      <div class="accountLoginMsg">
        <i class="el-icon-s-promotion"></i>
        <span>账号登录</span>
      </div>

      <div class="account">
        <input
          placeholder="请输入账号"
          v-model.number="username"
          type="text"
        />
      </div>

      <div class="pwd">
        <input
          placeholder="请输入密码"
          v-model.trim="pwd"
          type="password"
        />
      </div>

      <button class="loginBtn" @click="login">登录</button>

      <div class="pwdReg">
        <div class="forgetPwd" @click="$router.push('/forget')">忘记密码</div>
        <div>
          还没账号，<span class="reg" @click="$router.push('/reg')">立即注册<i class="el-icon-right"></i></span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Logo from '@/components/Logo.vue'
import { login } from '@/api/common'
import { mapState } from 'vuex'
export default {
  name: 'LoginIndex',
  components: { Logo },
  data () {
    return {
      username: '',
      pwd: ''
    }
  },
  created () {
    // 跳转到登录页，清空登录信息
    this.$store.commit('setUserInfo', {})
  },
  methods: {
    async login () {
      if (!this.username || !this.pwd) {
        this.$toast.fail('账号或密码不能为空')
        return
      }

      // 调用登录接口
      const result = await login(this.username + ':30', this.pwd)
      this.$store.commit('setUserInfo', result.data)

      // 登录成功，跳转到首页
      const backUrl = this.$route.query.backUrl || '/'
      this.$router.replace(backUrl)
      this.$toast.success('登录成功')
    }
  },
  computed: {
    ...mapState(['logoUrl'])
  }
}
</script>

<style lang="less" scoped>
.login {
  width: 100%;
  min-height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
  background: linear-gradient(135deg, #f8fafc, #eef6ff);
}

.login-card {
  width: 480px;
  padding: 40px;
  background: #fff;
  border-radius: 16px;
  box-shadow: 0 12px 32px rgba(0,0,0,0.1);
}

.accountLoginMsg {
  display: flex;
  align-items: center;
  margin-bottom: 10px;
  position: relative;

  i {
    font-size: 24px;
    color: #409EFF;
    margin-right: 12px;
  }

  span {
    font-size: 20px;
    color: #303133;
    font-weight: 500;
    letter-spacing: 1px;
  }

}

.account, .pwd {
  margin: 20px 0;

  input {
    width: 100%;
    height: 48px;
    padding: 0 20px;
    font-size: 14px;
    border: 1px solid #e4e7ed;
    border-radius: 8px;
    transition: all 0.3s ease;

    &:focus {
      border-color: #409EFF;
      box-shadow: 0 0 0 3px rgba(64,158,255,.1);
    }
  }
}

.loginBtn {
  width: 100%;
  height: 48px;
  background: linear-gradient(135deg, #409EFF, #67C23A);
  color: #fff;
  font-size: 16px;
  border: none;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.3s ease;
  margin-top: 20px;

  &:hover {
    opacity: 0.95;
    transform: translateY(-2px);
    box-shadow: 0 4px 15px rgba(64,158,255,.3);
  }
}

.pwdReg {
  display: flex;
  justify-content: space-between;
  margin-top: 25px;
  font-size: 14px;

  .forgetPwd, .reg {
    color: #409EFF;
    transition: all 0.3s ease;

    &:hover {
      color: #67C23A;
      transform: translateX(5px);
    }
  }

  .reg i {
    margin-left: 6px;
    font-size: 12px;
  }
}
</style>
